import { createApp } from 'vue';
import overview from '../../plugins/vue/overview';
import filters from '../../plugins/vue/filter';
import viewSwitch from '../../plugins/vue/switch';

if (
    document.querySelector('#grid-overview') ||
    document.querySelector('#filter') ||
    document.querySelector('#switch')
) {
    // Mounting the component
    createApp(overview).mount('#grid-overview');
    createApp(filters).mount('#grid-filter');
    createApp(viewSwitch).mount('#grid-switch');
}
